import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import ProductCategories from "views/admin/productCategories";
import Vendor from "views/admin/vendor";
import VendorProducts from "views/admin/vendorProducts";

const VENDOR_OPTIONS = [
  { label: "Vendor Categories", value: "categories" },
  { label: "Vendor Requests", value: "requests" },
  { label: "Vendor Products", value: "products" },
];

const VendorWrapper = () => {
  const [searchParams] = useSearchParams();
  const tabParam = searchParams.get("tab");
  const statusParam = searchParams.get("status");
  
  // Determine initial option based on URL params
  const getInitialOption = () => {
    // If tab parameter is "requests" or status parameter exists, show Vendor Requests
    if (tabParam === "requests" || statusParam) {
      return VENDOR_OPTIONS.find(opt => opt.value === "requests") || VENDOR_OPTIONS[0];
    } else if (tabParam === "products") {
      return VENDOR_OPTIONS.find(opt => opt.value === "products") || VENDOR_OPTIONS[0];
    } else if (tabParam === "categories") {
      return VENDOR_OPTIONS.find(opt => opt.value === "categories") || VENDOR_OPTIONS[0];
    }
    return VENDOR_OPTIONS[0]; // Default to categories
  };

  const [vendorOption, setVendorOption] = useState(getInitialOption());

  // Update option when URL params change
  useEffect(() => {
    let newOption;
    if (tabParam === "requests" || statusParam) {
      newOption = VENDOR_OPTIONS.find(opt => opt.value === "requests") || VENDOR_OPTIONS[0];
    } else if (tabParam === "products") {
      newOption = VENDOR_OPTIONS.find(opt => opt.value === "products") || VENDOR_OPTIONS[0];
    } else if (tabParam === "categories") {
      newOption = VENDOR_OPTIONS.find(opt => opt.value === "categories") || VENDOR_OPTIONS[0];
    } else {
      newOption = VENDOR_OPTIONS[0]; // Default to categories
    }
    setVendorOption(newOption);
  }, [tabParam, statusParam]);

  const renderVendor = () => {
    switch (vendorOption.value) {
      case "categories":
        return <ProductCategories key="vendor-categories" />;
      case "requests":
        return <Vendor key="vendor-requests" />;
      case "products":
        return <VendorProducts key="vendor-products" />;
      default:
        return <ProductCategories key="vendor-categories" />;
    }
  };

  return (
    <div className="mt-3 grid h-full grid-cols-1 gap-8">
      <div>{renderVendor()}</div>
    </div>
  );
};

export default VendorWrapper;

